<template lang="pug">
  .modal-card(style="with: auto")
    header.modal-card-head
      p.modal-card-title CSV
      a(:href="downloadPath") テンプレート
    section.modal-card-body
      b-field
        b-input(maxlength="200000" v-model="csv_text" type="textarea" rows="15" name="csv_text" v-validate="'required'")
    footer.modal-card-foot
      button.button.is-info.is-fullwidth(@click="onSubmit()") インポート

</template>

<script>
  import { Validator } from "vee-validate";
  import Papa from 'papaparse';
  import Encoding from 'encoding-japanese';

  export default {
    name: 'modal-csv-import-form',
    $_veeValidate: {
      validator: 'new'
    },
    data() {
      return {
        csv_text: ""
      }
    },
    props: {
      importCsvArray: {
        type: Function,
      },
      dynamicTyping: {
        type: Boolean,
        default: true
      },
      downloadPath: {
        type: String,
        default: '/CSV_upload_template.csv'
      }
    },
    methods: {
      setValidator(){
        if(Validator.rules['csv'] != undefined)
          return
        const isUnique = (value) =>
            new Promise(resolve => {
              setTimeout(() => {
                try {
                  Papa.parse(value, {
                    dynamicTyping: true,
                    skipEmptyLines: true,
                    complete: (results) => {
                      console.log(results)
                    },
                  });
                  return resolve({ valid: true });
                }catch(e){
                  return resolve({
                    valid: false,
                    data: {
                      message: `CSVデータが不正です。`
                    }
                  })
                }
              }, 10);
            });

        Validator.extend("csv", {
              validate: isUnique,
              getMessage: (field, params, data) => data.message
            }
        );
      },
      onSubmit(){
        this.$validator.validate('*').then((result) => {
          if (result) {
            try {
              Papa.parse(this.formattedCsvText(), {
                dynamicTyping: this.dynamicTyping,
                skipEmptyLines: true,
                complete: (results) => {
                  // console.log(results.data)
                  const length = results.data.length
                  //取次書店コードの頭に強制的に@をつけたので戻す
                  for(let i = 0; i < length; i++)
                    if(1 <= results.data[i].length && typeof results.data[i][1] == "string")
                      results.data[i][1] = results.data[i][1].replace(/^@/, "")
                  this.$emit('importCsvArray', results.data)
                  this.$parent.close()
                },
              });

            }catch(e){
              this.onError(e)
            }
            return
          }
          this.onError()
        })
      },
      onError(e = null){
        console.log(e)
        this.$toast.open({
          message: '登録情報エラーです。登録情報を確認してください。',
          type: 'is-danger',
          position: 'is-bottom',
          duration: 4000
        })
      },
      formattedCsvText() {
        let tmpText = this.csv_text
        if((this.csv_text.match(/ {4}/g) || []).length > 1)
          tmpText = this.csv_text.replace(/ {4}/g, '\t') //半角スペース4つをタブに
        tmpText = tmpText.replace(/ \t|\t /g, '\t') // 半角スペース+タブ or タブ+半角スペースをタブに
        tmpText = tmpText.replace(/ /g, '\t') // すべての半角スペースをタブに
        //取次書店コードの頭に強制的に@をつけることで数字ではなく文字列として認識させる
        let oldTmpText = tmpText
        tmpText = tmpText.replace(/^(\d+([ \t]+|,))(\d+)/m, "$1@$3")
        while(tmpText != oldTmpText){
          oldTmpText = tmpText
          tmpText = tmpText.replace(/^(\d+([ \t]+|,))(\d+)/m, "$1@$3")
        }
        // console.log(tmpText)
        return tmpText
      }
    },
    created() {
      // this.setValidator()
    }
  }
</script>
